import MenuManagePage from './MenuManagePage'
import withMenuManagePage from './withMenuManagePage'

const ConnectedMenuManagePage = withMenuManagePage(MenuManagePage)

export { ConnectedMenuManagePage as MenuManagePage }
